import { useState, useEffect } from "react";
import "./App.css";

import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import Login from "./Login";
import { getAuth, signOut } from "firebase/auth";

export default function App() {
useEffect(() => {
  if ("Notification" in window) {
    Notification.requestPermission();
  }
}, []);
const [user, setUser] = useState(null);
const authInstance = getAuth();

const handleLogout = async () => {
try {
await signOut(authInstance);
window.location.reload();
} catch (error) {
console.log(error);
}
};

const [currentTime, setCurrentTime] = useState(new Date());

useEffect(() => {
const interval = setInterval(() => {
setCurrentTime(new Date());
}, 1000);

return () => clearInterval(interval);
}, []);
useEffect(() => {
const unsub = onAuthStateChanged(auth, (u) => {
setUser(u);
});
return () => unsub();
}, []);

/* ---------------- STATE ---------------- */

const [tab, setTab] = useState("dashboard");

const [services, setServices] = useState([
{ name: "Cleaning", price: 100, cost: 40 }
]);

const [employees, setEmployees] = useState([
{ name: "Worker", rate: 60 }
]);

const [partners, setPartners] = useState([
{ name: "Partner 1", share: 50 },
{ name: "Partner 2", share: 50 }
]);

const [daily, setDaily] = useState([]);
const [materials, setMaterials] = useState([]);
const [bookings, setBookings] = useState([]);
const [fixedCosts, setFixedCosts] = useState([]);

const [cars, setCars] = useState("");
const [selectedService, setSelectedService] = useState(0);
const [selectedEmployee, setSelectedEmployee] = useState(0);

const [materialName, setMaterialName] = useState("");
const [materialCost, setMaterialCost] = useState("");

const [clientName, setClientName] = useState("");
const [bookingDate, setBookingDate] = useState("");
const [bookingTime, setBookingTime] = useState("");
const [bookingService, setBookingService] = useState(0);

const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");

const [loaded, setLoaded] = useState(false);
const [notifications, setNotifications] = useState([]);
const [showNotif, setShowNotif] = useState(false);
const [menuOpen, setMenuOpen] = useState(false);

/* ---------------- LOAD ---------------- */

useEffect(() => {
try {
const saved = localStorage.getItem("erp-data");

if (saved) {
const data = JSON.parse(saved);

setDaily(data.daily || []);
setMaterials(data.materials || []);
setEmployees(data.employees || []);
setServices(data.services || []);
setPartners(data.partners || []);
setBookings(data.bookings || []);
setFixedCosts(data.fixedCosts || []);
}

} catch {
localStorage.removeItem("erp-data");
}

setLoaded(true);
}, []);

/* ---------------- SAVE ---------------- */

useEffect(() => {
if (!loaded) return;

localStorage.setItem("erp-data", JSON.stringify({
daily,
materials,
employees,
services,
partners,
bookings,
fixedCosts
}));

}, [daily, materials, employees, services, partners, bookings, fixedCosts, loaded]);

/* ---------------- HELPERS ---------------- */

const euro = (n) => "€" + (Number(n) || 0).toFixed(2);

/* ---------------- WORK ---------------- */

const addWork = () => {
if (!cars) return;

setDaily([
...daily,
{
service: selectedService,
employee: selectedEmployee,
count: Number(cars) || 0,
date: new Date().toISOString()
}
]);

setCars("");
};

/* ---------------- FILTER ---------------- */

const filteredDaily = daily;

/* ---------------- CALCULATIONS ---------------- */

const revenue = filteredDaily.reduce((sum, d) => {
const s = services[d.service];
return sum + ((Number(s?.price) || 0) * (Number(d.count) || 0));
}, 0);

const costWork = filteredDaily.reduce((sum, d) => {
const e = employees[d.employee];
return sum + ((Number(e?.rate) || 0) * (Number(d.count) || 0));
}, 0)
const costMaterials = materials.reduce((sum, m) => {
return sum + (Number(m.cost) || 0);
}, 0);

const costFixed = fixedCosts.reduce((sum, c) => {
return sum + (Number(c.amount) || 0);
}, 0);

const cost = costWork + costMaterials + costFixed;
const profit = revenue - cost;

/* ---------------- UI ---------------- */
if (!user) {
return <Login setUser={setUser} />;
}
return (
<div className="app">

<div className="sidebar" style={{
  display: menuOpen ? "block" : "none"
}}>
<div style={{ textAlign: "center", marginBottom: "20px" }}>

<div style={{ fontSize: "28px" }}>
👑<span style={{ marginLeft: "-22px" }}>ARX</span>
</div>

<div style={{ fontFamily: "cursive" }}>Platform</div>

<div style={{
fontSize: "12px",
marginTop: "10px",
opacity: 0.7
}}>
🕒 {currentTime.toLocaleTimeString()}
<br />
📅 {currentTime.toLocaleDateString()}
</div>

</div>

<button onClick={()=>setTab("dashboard")}>📊 Dashboard</button>
<button onClick={()=>setTab("materials")}>📦 Materials</button>
<button onClick={()=>setTab("fixed")}>💸 Fixed Costs</button>
<button onClick={()=>setTab("daily")}>🧾 Daily Work</button>
<button onClick={()=>setTab("bookings")}>📅 Bookings</button>
<button onClick={()=>setTab("employee")}>🧑‍🔧 Employee</button>
<button onClick={()=>setTab("partners")}>🤝 Partners</button>
<hr style={{ margin: "15px 0", opacity: 0.2 }} />

<button onClick={()=>setTab("reports")}>📈 Reports</button>
<button onClick={()=>setTab("settings")}>⚙️ Settings</button>

<button
onClick={handleLogout}
style={{ marginTop: "20px", background: "#ff4d4f", color: "white" }}
>
🚪 Logout
</button>
</div>
<button onClick={() => setMenuOpen(!menuOpen)}>☰</button>
<div className="content">
<div style={{
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: "10px"
}}>

  <div
    onClick={() => setShowNotif(!showNotif)}
    style={{ position: "relative", cursor: "pointer" }}
  >

    🔔

    {notifications.length > 0 && (
      <div style={{
        position: "absolute",
        top: "-5px",
        right: "-10px",
        background: "red",
        color: "white",
        borderRadius: "50%",
        width: "18px",
        height: "18px",
        fontSize: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        {notifications.length}
      </div>
    )}

    {showNotif && (
      <div style={{
        position: "absolute",
        right: 0,
        top: "25px",
        background: "white",
        borderRadius: "10px",
        padding: "10px",
        width: "220px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
      }}>
        {notifications.length === 0 ? (
          <div>No notifications</div>
        ) : (
          notifications.map(n => (
            <div key={n.id} style={{
              padding: "6px",
              borderBottom: "1px solid #eee"
            }}>
              🚗 {n.text}
            </div>
          ))
        )}
      </div>
    )}

  </div>

</div>

{/* DASHBOARD */}
{tab === "dashboard" && (
<>
<h2>Dashboard</h2>
<div className="cards">
<div className="card revenue">Revenue <h3>{euro(revenue)}</h3></div>
<div className="card cost">Cost <h3>{euro(cost)}</h3></div>
<div className="card profit">Profit <h3>{euro(profit)}</h3></div>
</div>
</>
)}

{tab === "employee" && (
<>
<h2>Employee Stats</h2>

{employees.map((emp, i) => {

  const works = daily.filter(d => d.employee === i);

  const totalJobs = works.reduce((sum, w) => sum + (w.count || 0), 0);

  const totalRevenue = works.reduce((sum, w) => {
    const s = services[w.service];
    return sum + ((Number(s?.price) || 0) * (w.count || 0));
  }, 0);

  const totalCost = works.reduce((sum, w) => {
    return sum + ((Number(emp.rate) || 0) * (w.count || 0));
  }, 0);

  const totalProfit = totalRevenue - totalCost;

  return (
    <div key={i} style={{
      background: "#fff",
      padding: "15px",
      borderRadius: "12px",
      marginBottom: "10px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
    }}>

      <h3>{emp.name}</h3>

      <p>Jobs: {totalJobs}</p>
      <p>Revenue: €{totalRevenue.toFixed(2)}</p>
      <p>Cost: €{totalCost.toFixed(2)}</p>
      <p>Profit: €{totalProfit.toFixed(2)}</p>

    </div>
  );
})}

</>
)}

{/* DAILY WORK */}
{tab === "daily" && (
  <>
    <h2>Daily Work</h2>

    <select
      value={selectedService}
      onChange={(e) => setSelectedService(Number(e.target.value))}
    >
      {services.map((s, i) => (
        <option key={i} value={i}>
          {s.name} (€{s.price})
        </option>
      ))}
    </select>

    <select
      value={selectedEmployee}
      onChange={(e) => setSelectedEmployee(Number(e.target.value))}
    >
      {employees.map((e, i) => (
        <option key={i} value={i}>
          {e.name} (€{e.rate})
        </option>
      ))}
    </select>

    <input
      value={cars}
      onChange={(e) => setCars(e.target.value)}
      placeholder="Count"
    />

    <button onClick={addWork}>Add Work</button>

    <ul>
      {daily.map((d, i) => (
        <li key={i}>
          {services[d.service]?.name} × {d.count} — {employees[d.employee]?.name}

          <button
            onClick={() => {
              setDaily(daily.filter((_, index) => index !== i));
            }}
          >
            ❌
          </button>
        </li>
      ))}
    </ul>
  </>
)}

{/* MATERIALS */}
{tab === "materials" && (
<>
<h2>Materials</h2>

<input
value={materialName}
onChange={(e)=>setMaterialName(e.target.value)}
placeholder="Name"
/>

<input
value={materialCost}
onChange={(e)=>setMaterialCost(e.target.value)}
placeholder="Cost"
/>

<button onClick={()=>{
if(!materialName || !materialCost) return;

setMaterials([
...materials,
{name:materialName, cost:Number(materialCost)||0}
]);

setMaterialName("");
setMaterialCost("");
}}>
Add
</button>

<div style={{marginTop:15}}>

{materials.map((m,i)=>(
<div key={i} style={{
display:"flex",
justifyContent:"space-between",
background:"#f1f1f1",
padding:"10px",
borderRadius:"10px",
marginBottom:"6px"
}}>

<div>
{m.name} - {euro(m.cost)}
</div>

<button onClick={()=>{
setMaterials(materials.filter((_,x)=>x!==i))
}}>
❌
</button>

</div>
))}

</div>
</>
)}

{/* SETTINGS */}
{tab === "settings" && (
<>
<h2>Settings</h2>

<h3>Services</h3>
<div style={{
display:"grid",
gridTemplateColumns:"1fr 1fr 1fr auto",
gap:"10px",
fontWeight:"bold",
opacity:0.6,
marginBottom:"10px"
}}>
<div>Name</div>
<div>Price</div>
<div>Cost</div>
<div></div>
</div>
{services.map((s,i)=>(
<div key={i} style={{
display:"grid",
gridTemplateColumns:"1fr 1fr 1fr auto",
gap:"10px",
marginBottom:"8px",
alignItems:"center"
}}>
<input value={s.name}
onChange={(e)=>{
const copy=[...services];
copy[i].name=e.target.value;
setServices(copy);
}}/>

<input value={s.price}
onChange={(e)=>{
const copy=[...services];
copy[i].price=Number(e.target.value)||0;
setServices(copy);
}}/>

<input value={s.cost}
onChange={(e)=>{
const copy=[...services];
copy[i].cost=Number(e.target.value)||0;
setServices(copy);
}}/>

<button onClick={()=>setServices(services.filter((_,index)=>index!==i))}>❌</button>
</div>
))}

<button onClick={()=>setServices([...services,{name:"New",price:0,cost:0}])}>
Add Service
</button>

<h3>Employees</h3>
<div style={{
display:"grid",
gridTemplateColumns:"1fr 1fr auto",
gap:"10px",
fontWeight:"bold",
opacity:0.6,
marginBottom:"10px"
}}>
<div>Name</div>
<div>Rate</div>
<div></div>
</div>
{employees.map((e,i)=>(
<div key={i} style={{
display:"grid",
gridTemplateColumns:"1fr 1fr auto",
gap:"10px",
marginBottom:"8px",
alignItems:"center"
}}>
<input value={e.name}
onChange={(ev)=>{
const copy=[...employees];
copy[i].name=ev.target.value;
setEmployees(copy);
}}/>

<input value={e.rate}
onChange={(ev)=>{
const copy=[...employees];
copy[i].rate=Number(ev.target.value)||0;
setEmployees(copy);
}}/>

<button onClick={()=>setEmployees(employees.filter((_,index)=>index!==i))}>❌</button>
</div>
))}

<button onClick={()=>setEmployees([...employees,{name:"New",rate:0}])}>
Add Employee
</button>
</>
)}

{/* REPORTS */}
{tab === "reports" && (
<>
<h2>Reports</h2>

<input type="date" value={fromDate}
onChange={(e)=>setFromDate(e.target.value)}/>

<input type="date" value={toDate}
onChange={(e)=>setToDate(e.target.value)}/>

<p>Revenue: {euro(revenue)}</p>
<p>Cost: {euro(cost)}</p>
<p>Profit: {euro(profit)}</p>
</>
)}

{/* BOOKINGS */}
{tab === "bookings" && (
<>
<h2>Bookings</h2>

<input value={clientName}
onChange={(e)=>setClientName(e.target.value)}
placeholder="Client"/>

<input type="date"
value={bookingDate}
onChange={(e)=>setBookingDate(e.target.value)}/>

<input type="time"
value={bookingTime}
onChange={(e)=>setBookingTime(e.target.value)}/>

<select value={bookingService}
onChange={(e)=>setBookingService(Number(e.target.value))}>
{services.map((s,i)=>(
<option key={i} value={i}>{s.name} (€{s.price})</option>
))}
</select>

<button onClick={()=>{
if(!clientName || !bookingDate) return;

setBookings([...bookings,{
  id: Date.now(),
  client: clientName,
  date: bookingDate,
  time: bookingTime,
  service: bookingService,
  status: "pending",
  workerColor: "yellow"
}]);

setNotifications((prev) => {
  return [
    {
      id: Date.now(),
      text: clientName + " - " + bookingTime
    },
    ...prev
  ];
});



setClientName("");
setBookingDate("");
setBookingTime("");
}}>
Add Booking
</button>

<div style={{marginTop:20}}>

{/* GROUP BY DATE */}
{Object.entries(
bookings.reduce((acc, b) => {
if (!acc[b.date]) acc[b.date] = [];
acc[b.date].push(b);
return acc;
}, {})
).map(([date, items]) => (

<div key={date} style={{marginBottom:20}}>

<div style={{fontWeight:"bold", marginBottom:"10px"}}>
📅 {date}
</div>

{items.map((b)=>(
<div key={b.id} style={{
display:"grid",
gridTemplateColumns:"30px 1fr 140px 160px",
alignItems:"center",
gap:"10px",
background:
  b.status === "done" ? "#d4edda" :
  b.status === "no-show" ? "#f8d7da" :
  "#ffffff",
padding:"12px",
borderRadius:"12px",
marginBottom:"8px"
}}>

{/* COLOR DOT */}
<div style={{
width:"18px",
height:"18px",
borderRadius:"50%",
background:
  b.workerColor === "yellow" ? "gold" :
  b.workerColor === "lightblue" ? "dodgerblue" :
  "purple"
}}></div>

{/* INFO */}
<div>
<b>{b.time || "--:--"}</b> — {services[b.service]?.name}
<br/>
👤 {b.client}
</div>

{/* STATUS BUTTONS */}
<div style={{display:"flex", gap:"5px"}}>

<button onClick={()=>{
setBookings(bookings.map(bk =>
bk.id === b.id ? { ...bk, status: "done" } : bk
));
}}>
✔
</button>

<button onClick={()=>{
setBookings(bookings.map(bk =>
bk.id === b.id ? { ...bk, status: "no-show" } : bk
));
}}>
✖
</button>

<button onClick={()=>{
const colors=["yellow","lightblue","plum"];
const current=colors.indexOf(b.workerColor);
const next=colors[(current+1)%colors.length];

setBookings(bookings.map(bk =>
bk.id === b.id ? { ...bk, workerColor: next } : bk
));
}}>
🎨
</button>

</div>

{/* DELETE */}
<button onClick={()=>{
setBookings(bookings.filter(bk => bk.id !== b.id));
}}>
❌
</button>

</div>
))}

</div>
))}

</div>
</>
)}

{/* PARTNERS */}
{tab === "partners" && (
<div className="section">
<h2>Partners</h2>

<div style={{marginBottom:20}}>
{partners.map((p,i)=>(
<div key={i} style={{
display: "flex",
gap: "10px",
marginBottom: "10px",
alignItems: "center"
}}>

<input value={p.name}
onChange={(e)=>{
const copy=[...partners];
copy[i].name=e.target.value;
setPartners(copy);
}}/>

<input type="number"
value={p.share}
onChange={(e)=>{
const copy=[...partners];
copy[i].share=Number(e.target.value)||0;
setPartners(copy);
}}/>

<button onClick={()=>setPartners(partners.filter((_,index)=>index!==i))}>
❌
</button>

</div>
))}
</div>

<button onClick={()=>setPartners([...partners,{name:"New Partner",share:0}])}>
Add Partner
</button>

<h3 style={{marginTop:30}}>Profit Split</h3>

<div className="section">
{partners.map((p,i)=>(
<div key={i} style={{
padding:"10px",
marginBottom:"8px",
borderRadius:"10px",
background:"#f5f5f5"
}}>
<strong>{p.name}</strong>: {euro((profit * (p.share || 0)) / 100)}
</div>
))}
</div>

</div>
)}


{/* FIXED COSTS */}
{tab === "fixed" && (
<>
<h2>Monthly Costs</h2>

{fixedCosts.map((c,i)=>(
<div key={i}>
<input value={c.name}
onChange={(e)=>{
const copy=[...fixedCosts];
copy[i].name=e.target.value;
setFixedCosts(copy);
}}/>

<input value={c.amount}
onChange={(e)=>{
const copy=[...fixedCosts];
copy[i].amount=Number(e.target.value);
setFixedCosts(copy);
}}/>

<button onClick={()=>setFixedCosts(fixedCosts.filter((_,index)=>index!==i))}>❌</button>
</div>
))}

<button onClick={()=>setFixedCosts([...fixedCosts,{name:"New",amount:0}])}>
Add Cost
</button>
</>
)}

</div>
</div>
);
}
